import { render, staticRenderFns } from "./pricelist.vue?vue&type=template&id=7908da3d&"
import script from "./pricelist.vue?vue&type=script&lang=js&"
export * from "./pricelist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7908da3d')) {
      api.createRecord('7908da3d', component.options)
    } else {
      api.reload('7908da3d', component.options)
    }
    module.hot.accept("./pricelist.vue?vue&type=template&id=7908da3d&", function () {
      api.rerender('7908da3d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2xkQrndBlEdtZ/JS/comp/pricelist.vue"
export default component.exports